export const normalizeCreatorBoostCode = (code: string | null | undefined) => code?.trim().toLowerCase() ?? ''
